import React, {useContext} from 'react';
import {AuditContext} from '../context/AuditProvider';
import {CalendarContext} from '../context/CalendarProvider';
import AuditOverviewHeaderTitle from '../components/AuditOverviewHeaderTitle';
import AuditOverviewHeader from '../components/AuditOverviewHeader';
import Overview from '../../components/UI/Overview/Overview';
import AuditFooter from '../components/AuditFooter';
import {Row, Container} from 'react-bootstrap';

function AuditOverviewContainer(props) {    

    const { overview, isBtnExportEnable, handlerOnOverviewDataSelection } = useContext(AuditContext); 
    const { fromMinDate, fromRevenueDate, fromMaxDate, untilMinDate, untilRevenueDate, untilMaxDate, isValidDateRange,
        fromDateHandler, untilDateHandler, setIsValidDateRange } = useContext(CalendarContext);  
    return (
        <>
            {   overview && <Container>  
                    <Row>
                        <AuditOverviewHeaderTitle />
                    </Row>
                    <Row className="audit-overview-btn-row">
                        <AuditOverviewHeader fromRevenueDate= {fromRevenueDate} 
                        untilRevenueDate= {untilRevenueDate} isValidDateRange={isValidDateRange}
                        isOverviewDataAvailable={overview && overview.length > 0} />
                    </Row>
                    <Row>
                        {overview && <Overview   overview={overview}
                            isAudit={true}
                            overviewDataSelectionHandler={handlerOnOverviewDataSelection} 
                            isBtnDetailsEnable={isBtnExportEnable}
                        />}
                    </Row>
                    <Row>
                        <AuditFooter fromMinDate= {fromMinDate} 
                            fromRevenueDate= {fromRevenueDate} 
                            fromMaxDate= {fromMaxDate}
                            untilMinDate= {untilMinDate} 
                            untilRevenueDate= {untilRevenueDate}
                            untilMaxDate= {untilMaxDate}
                            onFromDateChange = {fromDateHandler}
                            onUntilDateChange={untilDateHandler} 
                            setIsValidDateRange={setIsValidDateRange} />
                    </Row>
                </Container>
            }
        </>
    );
}

export default AuditOverviewContainer;